import { render, staticRenderFns } from "./TheOfficialHeader.vue?vue&type=template&id=3acd22b6&scoped=true"
import script from "./TheOfficialHeader.vue?vue&type=script&lang=ts"
export * from "./TheOfficialHeader.vue?vue&type=script&lang=ts"
import style0 from "./TheOfficialHeader.vue?vue&type=style&index=0&id=3acd22b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acd22b6",
  null
  
)

export default component.exports